<h2 mat-dialog-title>{{addOrEditText}} Issue</h2>
<mat-dialog-content>
  <form [formGroup]="issueFormGroup">
    <mat-form-field style="padding-top: 15px; width: 100%">
      <input matInput placeholder="Title" formControlName="issueTitle"/>
      <mat-error
        *ngIf="issueFormGroup.controls['issueTitle'].invalid && (issueFormGroup.controls['issueTitle'].touched || issueFormGroup.controls['issueTitle'].dirty)">
        <p *ngIf="issueFormGroup.controls['issueTitle'].errors.maxlength">Name can not exceed <strong>256</strong>
          characters.</p>
      </mat-error>
    </mat-form-field>
    <mat-form-field style="padding-top: 15px; width: 100%">
      <input matInput placeholder="Description" formControlName="description"/>
      <mat-error
        *ngIf="issueFormGroup.controls['description'].invalid && (issueFormGroup.controls['description'].touched || issueFormGroup.controls['description'].dirty)">
        <p *ngIf="issueFormGroup.controls['description'].errors.maxlength">Name can not exceed <strong>1024</strong>
          characters.</p>
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" [disabled]="!issueFormGroup.valid" (click)="ok()">Ok</button>
  <button mat-raised-button color="secondary" (click)="cancel()">Cancel</button>
</mat-dialog-actions>
